export const languageNativeNames = {
  ar: 'العربية',
  ca: 'Català',
  cs: 'Čeština',
  de: 'Deutsch',
  dk: 'Dansk',
  en: 'English',
  es: 'Español',
  eu: 'Euskara',
  uz: 'O`zbekcha',
  ro: 'Română',
  fr: 'Français',
  gu: 'Gujarati',
  he: 'עברית',
  hr: 'Hrvatski',
  hu: 'Magyar',
  id: 'Indonesian',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  ml: 'Malayalam',
  ms: 'Melayu',
  nl: 'Nederlands',
  no: 'Norwegian',
  pl: 'Polski',
  'pt-BR': 'Português (Brasil)',
  pt: 'Português (Portugal)',
  ru: 'Русский',
  sk: 'Slovenčina',
  sv: 'Swedish',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  'zh-Hans': '中文 (简体)',
  zh: '中文 (繁體)',
  sa: 'संस्कृत',
  hi: 'हिन्दी',
} as const;
